import React from 'react'
import MaterialSymbol from '../material-symbol'

const AttachMoney = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="attach_money" {...props} />
))

AttachMoney.displayName = 'AttachMoney'

export default AttachMoney
